export class Tabs {
  constructor () {
    document.querySelectorAll('[data-tabs]').forEach((root) => this.mount(root))
  }

  mount (root) {
    const tabs = [...root.querySelectorAll('[role="tab"]')]
    const panels = [...root.querySelectorAll('[role="tabpanel"]')]

    if (!tabs.length || !panels.length) {
      return
    }

    const activate = (index) => {
      tabs.forEach((tab, i) => {
        const selected = i === index
        tab.classList.toggle('is-active', selected)
        tab.setAttribute('aria-selected', selected ? 'true' : 'false')
        tab.tabIndex = selected ? 0 : -1
      })

      panels.forEach((panel, i) => {
        panel.hidden = i !== index
      })
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i))
      tab.addEventListener('keydown', (event) => {
        const vertical = root.closest('.s-tabs--right, .s-tabs--left')
          && window.matchMedia('(min-width: 1025px)').matches
        const nextKey = vertical ? 'ArrowDown' : 'ArrowRight'
        const prevKey = vertical ? 'ArrowUp' : 'ArrowLeft'

        if (event.key !== nextKey && event.key !== prevKey && event.key !== 'Home' && event.key !== 'End') {
          return
        }

        event.preventDefault()
        let next = i
        if (event.key === nextKey) {
          next = (i + 1) % tabs.length
        } else if (event.key === prevKey) {
          next = (i - 1 + tabs.length) % tabs.length
        } else if (event.key === 'Home') {
          next = 0
        } else {
          next = tabs.length - 1
        }

        tabs[next].focus()
        activate(next)
      })
    })
  }
}
